<template>
    <div>
        <el-scrollbar class="equipment_scroll">
            <div class="equipment_edit">
                <!-- <div class="group" v-for="(value, key) in dataMap" :key="key">
                <div class="group_title">{{ key }}</div>-->

                <!-- class="leader-style-form leader-form-inline" -->
                <formCreate
                    v-model="ffApi"
                    :rule="rule"
                    :option="options"
                    class="leader-style-form"
                ></formCreate>
                <!-- </div> -->
            </div>
        </el-scrollbar>
        <div slot="footer" class="dialog-footer footer">
            <el-button aligen="center" plain @click="onResetf" class="leader-common-button">取消</el-button>
            <el-button @click="onSubmitf" type="primary" class="leader-common-button">保存</el-button>
        </div>
    </div>
</template>
<script>
import * as api from '../../api/index';
import formCreate, { maker } from '@form-create/element-ui';
export default {
    components: {
        formCreate: formCreate.$form(),
    },
    props: {
        editColumn: Object,
        currentTreeNode: Object,
        currentData: Object,
    },
    data() {
        return {
            dataMap: {},
            currentTreeNode: this.currentTreeNode,
            editColumn: this.editColumn,
            ffApi: {},
            options: {
                submitBtn: false,
                resetBtn: false,
            },
            rule: [],
            currentTreeTypeId: '',
        };
    },
    watch: {
        async editColumn(val) {
            //  this.rule = [];
            const dataMap = {};
            let genRule = [];
            for (let key in val) {
                let children = [];
                children.push(
                    formCreate,
                    maker
                        .create('div')
                        .props({
                            type: 'div',
                            class: 'group_title',
                        })
                        .children([key])
                );
                // val[key].forEach((item, index) => {
                for (let index = 0; index < val[key].length; index++) {
                    let item = val[key][index];
                    if (item.colum_type == 'select') {
                        if (!item.need_colum_id) {
                            if (
                                item.colum_id == 'cq_000005' ||
                                item.colum_id == 'cq_000003' ||
                                item.colum_id == 'pdbyq_000003'
                            ) {
                                this.currentTreeTypeId = item.colum_value;
                                let option_temp = await api
                                    .getSelectTwo({
                                        tree_level: this.currentTreeNode
                                            .tree_level,
                                    })
                                    .then((res) => {
                                        const options = [];
                                        res.bus_json.forEach(
                                            (_item, _index) => {
                                                options.push({
                                                    value: _item.tree_type_id,
                                                    label: _item.tree_type_name,
                                                    disabled: false,
                                                });
                                            }
                                        );
                                        return options;
                                    });
                                children.push({
                                    type: 'select',
                                    field:
                                        item.colum_id +
                                        '-' +
                                        item.tree_colum_id,
                                    title: item.colum_title,
                                    value: item.colum_value,
                                    select: null,
                                    options: option_temp,
                                    col: {
                                        span: 12,
                                        labelWidth: 120,
                                    },
                                    props: {
                                        multiple: false,
                                        disabled:
                                            item.is_update == '1'
                                                ? true
                                                : false,
                                    },
                                    inject: true,
                                    on: {
                                        change: this.changeTreeType,
                                    },
                                    validate: [
                                        {
                                            required:
                                                item.colum_required == '1',
                                            message:
                                                '请选择' + item.colum_title,
                                        },
                                    ],
                                });
                                // console.log(children);
                            } else {
                                let option_temp = await api
                                    .getSelect({
                                        colum_id: item.colum_id,
                                    })
                                    .then((res) => {
                                        const options = [];
                                        res.bus_json.forEach(
                                            (_item, _index) => {
                                                options.push({
                                                    value: _item.code_value,
                                                    label: _item.code_name,
                                                    disabled: false,
                                                });
                                            }
                                        );
                                        return options;
                                    });
                                children.push({
                                    type: 'select',
                                    field:
                                        item.colum_id +
                                        '-' +
                                        item.tree_colum_id,
                                    title: item.colum_title,
                                    value: item.colum_value,
                                    select: null,
                                    options: option_temp,
                                    col: {
                                        span: 12,
                                        labelWidth: 120,
                                    },
                                    props: {
                                        multiple: false,
                                        disabled:
                                            item.is_update == '1'
                                                ? true
                                                : false,
                                    },
                                    inject: true,
                                    on: {
                                        change: this.change,
                                    },
                                    validate: [
                                        {
                                            required:
                                                item.colum_required == '1',
                                            message:
                                                '请选择' + item.colum_title,
                                        },
                                    ],
                                });
                            }
                        } else {
                            const options = this.querySubOptions(item); //下拉框必须有级联顺序从上到下
                            children.push({
                                type: 'select',
                                field: item.colum_id + '-' + item.tree_colum_id,
                                title: item.colum_title,
                                value: item.colum_value,
                                select: item.need_colum_id,
                                options: options,
                                col: {
                                    span: 12,
                                    labelWidth: 120,
                                },
                                props: {
                                    multiple: false,
                                    disabled: false,
                                },
                                inject: true,
                                on: {
                                    change: this.change,
                                    'visible-change': this.visibleChange,
                                },
                                validate: [
                                    {
                                        required: item.colum_required == '1',
                                        message: '请选择' + item.colum_title,
                                    },
                                ],
                            });
                        }
                    } else if (item.colum_type == 'date') {
                        children.push({
                            type: 'DatePicker',
                            field: item.colum_id + '-' + item.tree_colum_id,
                            title: item.colum_title,
                            value: item.colum_value,
                            props: {
                                type: 'date',
                                format: 'yyyy-MM-dd',
                                placeholder: `请选择${item.colum_title}`,
                                disabled: item.is_update == '1' ? true : false,
                            },
                            col: {
                                span: 12,
                                labelWidth: 120,
                            },
                            validate: [
                                {
                                    required: item.colum_required == '1',
                                    message: '请选择' + item.colum_title,
                                },
                            ],
                        });
                    } else if (item.colum_type == 'text') {
                        children.push({
                            type: 'input',
                            field: item.colum_id + '-' + item.tree_colum_id,
                            title: item.colum_title,
                            value: item.colum_value,
                            props: {
                                maxlength: item.max_length,
                                disabled: item.is_update == '1' ? true : false,
                            },
                            col: {
                                span: 12,
                                labelWidth: 120,
                            },
                            validate: [
                                {
                                    required: item.colum_required == '1',
                                    message: '请输入' + item.colum_title,
                                    trigger: 'blur',
                                },
                            ],
                        });
                    } else if (item.colum_type == 'radio') {
                        children.push({
                            type: 'radio',
                            field: item.colum_id + '-' + item.tree_colum_id,
                            title: item.colum_title,
                            value: item.colum_value,
                            options: [
                                { value: '0', label: '否', disabled: false },
                                { value: '1', label: '是', disabled: false },
                            ],
                            props: {
                                disabled: item.is_update == '1' ? true : false,
                            },
                            col: {
                                span: 12,
                                labelWidth: 120,
                            },
                            validate: [
                                {
                                    required: item.colum_required == '1',
                                    message: '请选择' + item.colum_title,
                                },
                            ],
                        });
                    }
                    // });
                }
                genRule.push(
                    formCreate.maker
                        .create('div')
                        .props({
                            type: 'div',
                            class: 'group',
                        })
                        .children(children)
                );
            }
            this.rule = genRule;
            //console.log(this.rule);
        },
    },
    methods: {
        onSubmitf() {
            this.ffApi.submit((formData, $f) => {
                const treeColumList = [];
                for (var key in formData) {
                    let splitIds = key.split('-');
                    treeColumList.push({
                        colum_id: splitIds[0],
                        tree_colum_id: splitIds[1],
                        colum_value: formData[key],
                    });
                }
                api.updateTreeColum({
                    tree_id: this.currentData.tree_id,
                    tree_name: this.currentTreeNode.tree_name,
                    p_tree_id: this.currentTreeNode.tree_id,
                    tree_level: this.currentTreeNode.tree_level,
                    tree_type_id: this.currentTreeNode.tree_type_id,
                    treeColumList: treeColumList,
                }).then((res) => {
                    this.$emit('closeDialog', true);
                });
            });
        },
        onResetf() {
            this.$emit('closeDialog');
        },
        querySubOptions(data) {
            let options = [];
            let editColumnList = [];
            for (let key in this.editColumn) {
                editColumnList = [...editColumnList, ...this.editColumn[key]];
            }
            editColumnList.forEach((item, index) => {
                if (
                    item.colum_id == data.need_colum_id &&
                    item.colum_value != '' &&
                    item.colum_value != null
                ) {
                    api.getSelect({
                        colum_id: data.colum_id,
                        p_code_value: item.colum_value,
                    }).then((res) => {
                        res.bus_json.forEach((item, index) => {
                            options.push({
                                value: item.code_value,
                                label: item.code_name,
                                disabled: false,
                            });
                        });
                    });
                }
            });
            return options;
        },
        changeTreeType(inject) {
            let self = inject.self;
            this.currentTreeTypeId = self.value;
            //初始化下级下拉框
            this.resetVal(inject.self.field, inject.rule);
            //查询下级下拉框的options
            this.queryCascadeOptions(inject);
        },
        change(inject) {
            //初始化下级下拉框
            this.resetVal(inject.self.field, inject.rule);
            //查询下级下拉框的options
            this.queryCascadeOptions(inject);
        },
        queryCascadeOptions(inject) {
            let editColumnList = [];
            for (let key in this.editColumn) {
                editColumnList = [...editColumnList, ...this.editColumn[key]];
            }
            const inject_self_colum_id = inject.self.field.split('-')[0];
            editColumnList.forEach((item, index) => {
                if (item.need_colum_id == inject_self_colum_id) {
                    //======查询接口
                    api.getSelect({
                        colum_id: item.colum_id,
                        p_code_value: inject.self.value,
                    }).then((res) => {
                        const options = [];
                        res.bus_json.forEach((item, index) => {
                            options.push({
                                value: item.code_value,
                                label: item.code_name,
                                disabled: false,
                            });
                        });

                        inject.rule.forEach((_item, _index) => {
                            if (_item._data.children) {
                                _item._data.children.forEach(
                                    (d_item, d_index) => {
                                        if (
                                            d_item.field ==
                                            item.colum_id +
                                            '-' +
                                            item.tree_colum_id
                                        ) {
                                            d_item.options = options;
                                        }
                                    }
                                );
                            }
                        });
                    });
                }
            });
        },
        resetVal(colum_id, rules) {
            if (colum_id && rules) {
                rules.forEach((_item, _index) => {
                    if (_item._data.children) {
                        _item._data.children.forEach((d_item, d_index) => {
                            if (d_item.select == colum_id.split('-')[0]) {
                                this.$set(d_item, 'value', '');
                                this.$set(d_item, 'options', []);
                                this.resetVal(d_item.field, rules);
                            }
                        });
                    }
                });
            }
        },
        visibleChange(inject, flag) {
            if (flag) {
                let editColumnList = [];
                for (let key in this.editColumn) {
                    editColumnList = [
                        ...editColumnList,
                        ...this.editColumn[key],
                    ];
                }
                editColumnList.forEach((item, index) => {
                    if (
                        inject.self.select == item.colum_id &&
                        !this.ffApi.form[
                        item.colum_id + '-' + item.tree_colum_id
                        ]
                    ) {
                        this.$message({
                            type: 'info',
                            message: '请先选择' + item.colum_title,
                        });
                    }
                });
            }
        },
    },
};
</script>
<style lang="scss">
.equipment_edit {
    .group {
        //border:2px solid #1e4283;
        //  border:2px solid #ffffff;
        padding: 0 15px;
        margin: 10px 0 20px 0;
    }
    .group::after {
        content: " "; /*加一段内容*/
        display: block; /*让生成的元素以块级元素显示，占满剩余空间*/
        height: 0; /*避免生成的内容破坏原有布局高度*/
        clear: both; /*清除浮动*/
        visibility: hidden; /*让生成的内容不可见*/
    }
    .group_title {
        height: 20px;
        vertical-align: middle;
        z-index: 0;
        color: #333333;
        font-size: 15px;
        margin: 0px 0 20px 20px;
    }
    .mailTable {
        margin-left: 0 !important;
    }
}
</style>
